var _rect, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 2,
    x2: 11,
    y2: 30,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 2,
    x2: 21,
    y2: 30,
    stroke: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/view_2.33a26dad.svg";
export { SvgComponent as ReactComponent };